import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSaFailedToJoin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 200,
	fill: "none",
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-accent, #A81A6A)",
			d: "m125.7 120.02-19.4-6.37 4.84 23.54H79.96a7.07 7.07 0 0 1-7.07-7.07V81.49a7.07 7.07 0 0 1 7.07-7.07h38.66a7.1 7.1 0 0 1 7.07 7.07z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			d: "M40.47 52.42a2.42 2.42 0 1 1-4.84 0 2.42 2.42 0 0 1 4.84 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			d: "M101.95 123.4a2.3 2.3 0 1 1-4.61.08 2.3 2.3 0 0 1 4.6-.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			d: "M23.89 106.92v9.74a4.86 4.86 0 1 1 0-9.74"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			d: "M47.97 111.91a4.87 4.87 0 0 1-4.87 4.88v-9.74a4.84 4.84 0 0 1 4.87 4.86"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			d: "M39.07 122.61a1.96 1.96 0 1 1-3.93 0 1.96 1.96 0 0 1 3.93 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-error-shade-deep, #FF6642)",
			d: "M187.17 76.8a1.21 1.21 0 1 1-2.42 0 1.21 1.21 0 0 1 2.42 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint0_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M79.96 74.44a7.07 7.07 0 0 0-7.07 7.07v48.62a7.07 7.07 0 0 0 7.07 7.08h31.18l-4.84-23.54 19.4 6.37V81.49a7.07 7.07 0 0 0-7.08-7.07c0 .02-38.66.02-38.66.02"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint1_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M124.88 24.38a2.17 2.17 0 1 1-4.35 0 2.17 2.17 0 0 1 4.34 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint2_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M113.52 148.81H35.14a6.6 6.6 0 0 1-6.58-6.58V130.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint3_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M28.56 88.71V49.56A6.6 6.6 0 0 1 35.14 43h128.9a6.6 6.6 0 0 1 6.57 6.58V88.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint4_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M170.61 130.5v11.74a6.6 6.6 0 0 1-6.58 6.57h-18.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint5_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M170.61 61.81H28.56"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint6_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M40.47 52.42a2.42 2.42 0 1 1-4.84 0 2.42 2.42 0 0 1 4.84 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint7_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M47.8 52.42a2.42 2.42 0 1 1-4.83 0 2.42 2.42 0 0 1 4.83 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint8_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M55.16 52.42a2.42 2.42 0 1 1-4.84 0 2.42 2.42 0 0 1 4.84 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint9_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M61.51 96.4a7.7 7.7 0 0 0-7.7-7.69H13.18a7.7 7.7 0 0 0-7.7 7.7v26.4a7.7 7.7 0 0 0 7.7 7.7h40.66a7.7 7.7 0 0 0 7.7-7.7c-.02 0-.02-26.4-.02-26.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint10_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M149.87 130.5h36.96a7.7 7.7 0 0 0 7.7-7.7V96.39a7.7 7.7 0 0 0-7.7-7.7h-40.66a7.7 7.7 0 0 0-7.7 7.7c0 27.86-.07 26.58.14 27.86"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint11_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M99.45 113.65c-.02-2.91 1.07-5.06 4.65-9.98s3.97-7 4-9.47a8.08 8.08 0 1 0-16.06 1.05"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint12_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M101.95 123.4a2.3 2.3 0 1 1-4.61.08 2.3 2.3 0 0 1 4.6-.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#sa-failed-to-join_svg__paint13_linear_4001_7813)",
			fillRule: "evenodd",
			d: "M177.72 106.02c0-6.36-12.35-8.02-12.35-8.02v16.05c2.75-.37 12.35-1.67 12.35-8.03M159 118.1c0-2.73 3.62-3.69 6.37-4.05V122s-6.37-.8-6.37-3.9",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint14_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M43.1 107.03a9.6 9.6 0 0 0-19.2 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint15_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M39.07 122.61a6.47 6.47 0 0 0 6.47-6.47"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint16_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M23.89 106.92a4.88 4.88 0 0 0 0 9.75z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint17_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M43.1 116.77a4.88 4.88 0 1 0 0-9.75z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint18_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M39.07 122.61a1.96 1.96 0 1 1-3.93 0 1.96 1.96 0 0 1 3.93 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint19_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M10.97 68.96V79.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint20_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M16.44 74.43H5.48"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint21_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M185.96 55.55v14.98"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint22_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m56.18 68.26 8.98 8.37"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint23_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M99.35 50v14.12"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint24_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m141.67 68.26-8.11 8.54"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint25_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m56.18 142.84 8.98-8.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint26_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M99.35 161.08v-14.65"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint27_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m116.05 161.14 13.23-11.99 17.43 19.64 9.4-8.5-17.41-19.64 13.23-12-45.64-15z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint28_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M58.14 176.1a5.75 5.75 0 0 1 2.54-10.91"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint29_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M63.27 165.8a5.73 5.73 0 0 1-2.37 10.86"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint30_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m59.49 164.1 1.19 1.1-1.1 1.18"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#sa-failed-to-join_svg__paint31_linear_4001_7813)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m62.04 177.8-1.15-1.12 1.13-1.14"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint0_linear_4001_7813",
				x1: 99.291,
				x2: 97.502,
				y1: 127.867,
				y2: 85.848,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint1_linear_4001_7813",
				x1: 122.701,
				x2: 122.597,
				y1: 25.907,
				y2: 22.996,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint2_linear_4001_7813",
				x1: 71.038,
				x2: 70.943,
				y1: 146.088,
				y2: 133.806,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint3_linear_4001_7813",
				x1: 99.585,
				x2: 99.231,
				y1: 81.913,
				y2: 51.257,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint4_linear_4001_7813",
				x1: 158.275,
				x2: 157.948,
				y1: 146.089,
				y2: 133.815,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint5_linear_4001_7813",
				x1: 99.584,
				x2: 99.584,
				y1: 62.663,
				y2: 61.993,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint6_linear_4001_7813",
				x1: 38.048,
				x2: 37.932,
				y1: 54.116,
				y2: 50.875,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint7_linear_4001_7813",
				x1: 45.383,
				x2: 45.267,
				y1: 54.116,
				y2: 50.875,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint8_linear_4001_7813",
				x1: 52.737,
				x2: 52.621,
				y1: 54.116,
				y2: 50.875,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint9_linear_4001_7813",
				x1: 33.501,
				x2: 32.753,
				y1: 124.296,
				y2: 96.29,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint10_linear_4001_7813",
				x1: 166.493,
				x2: 165.745,
				y1: 124.277,
				y2: 96.271,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint11_linear_4001_7813",
				x1: 100.016,
				x2: 98.876,
				y1: 109.522,
				y2: 90.982,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint12_linear_4001_7813",
				x1: 99.641,
				x2: 99.531,
				y1: 125.062,
				y2: 121.974,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint13_linear_4001_7813",
				x1: 159,
				x2: 168.869,
				y1: 98,
				y2: 125.211,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-ramp-1, #FF8164)" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .508,
						stopColor: "var(--illu-error-ramp-2, #FF6642)",
						stopOpacity: .97
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .876,
						stopColor: "var(--illu-error-ramp-3, #FF542C)",
						stopOpacity: .93
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "var(--illu-error-ramp-4, #F2471F)"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint14_linear_4001_7813",
				x1: 33.494,
				x2: 33.384,
				y1: 105.633,
				y2: 99.327,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint15_linear_4001_7813",
				x1: 42.303,
				x2: 42.148,
				y1: 121.649,
				y2: 117.318,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint16_linear_4001_7813",
				x1: 21.451,
				x2: 20.985,
				y1: 115.22,
				y2: 108.716,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint17_linear_4001_7813",
				x1: 45.534,
				x2: 45.068,
				y1: 115.319,
				y2: 108.814,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint18_linear_4001_7813",
				x1: 37.103,
				x2: 37.009,
				y1: 123.992,
				y2: 121.359,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint19_linear_4001_7813",
				x1: 11.467,
				x2: 8.973,
				y1: 78.276,
				y2: 71.915,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint20_linear_4001_7813",
				x1: 10.957,
				x2: 10.955,
				y1: 75.282,
				y2: 74.611,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint21_linear_4001_7813",
				x1: 186.461,
				x2: 182.28,
				y1: 68.3,
				y2: 60.504,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint22_linear_4001_7813",
				x1: 60.668,
				x2: 60.481,
				y1: 75.388,
				y2: 69.779,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint23_linear_4001_7813",
				x1: 99.847,
				x2: 96.034,
				y1: 62.018,
				y2: 54.478,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint24_linear_4001_7813",
				x1: 137.612,
				x2: 137.396,
				y1: 75.533,
				y2: 69.812,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint25_linear_4001_7813",
				x1: 60.668,
				x2: 60.48,
				y1: 141.591,
				y2: 135.969,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint26_linear_4001_7813",
				x1: 99.847,
				x2: 95.805,
				y1: 158.903,
				y2: 151.2,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint27_linear_4001_7813",
				x1: 131.203,
				x2: 129.739,
				y1: 160.593,
				y2: 123.676,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint28_linear_4001_7813",
				x1: 57.803,
				x2: 57.309,
				y1: 174.47,
				y2: 167.19,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint29_linear_4001_7813",
				x1: 63.665,
				x2: 63.155,
				y1: 175.046,
				y2: 167.806,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint30_linear_4001_7813",
				x1: 60.082,
				x2: 59.979,
				y1: 166.038,
				y2: 164.524,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "sa-failed-to-join_svg__paint31_linear_4001_7813",
				x1: 61.462,
				x2: 61.358,
				y1: 177.46,
				y2: 175.958,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-error-grad-from, #D9401C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-error-grad-to, #E5A000)"
				})]
			})
		] })
	]
});
export default SvgSaFailedToJoin;
